<!--
  Root Application Template

  This template provides two layout modes:
  1. Authenticated Layout: Shows header, sidebar, and main content area
  2. Unauthenticated Layout: Shows only the router outlet for auth pages

  The p-toast component is always present for global notifications.
  Includes semantic HTML landmarks and skip navigation link for accessibility.
-->

<!-- Skip to main content link (visible on focus for keyboard users) -->
<a href="#main-content" class="skip-link">
  Skip to main content
</a>

<!-- Global toast notifications -->
<p-toast role="region" aria-label="Notifications" aria-live="polite"></p-toast>

<!-- Authenticated Layout -->
<ng-container *ngIf="isAuthenticated$ | async; else authLayout">
  <!-- Header with user menu and logout -->
  <app-header></app-header>

  <!-- Main container with sidebar and content -->
  <div class="main-container" [class.sidebar-collapsed]="sidebarCollapsed">
    <!-- Navigation sidebar -->
    <app-sidebar (collapsedChange)="onSidebarCollapsedChange($event)"></app-sidebar>

    <!-- Main content area -->
    <main #mainContent id="main-content" class="content" role="main">
      <router-outlet></router-outlet>
    </main>
  </div>
</ng-container>

<!-- Unauthenticated Layout (Auth Pages) -->
<ng-template #authLayout>
  <main id="main-content" role="main">
    <router-outlet></router-outlet>
  </main>
</ng-template>

<!-- Session Timeout Warning Dialog -->
<app-session-timeout
  [visible]="showSessionTimeoutWarning"
  [remainingSeconds]="sessionTimeRemaining"
  (stayLoggedIn)="onStayLoggedIn()"
  (logout)="onLogout()">
</app-session-timeout>
